<template>
		<div>
			<div id="videoplayer" style="height:250px;width: 100%;"></div>
			<div id="video_container">
				<v-tree :data="courseResourceTreeTrySeeData" show-line @select='coursetreeplay'></v-tree>
            </div>
	</div>
</template>
<script src="//player.polyv.net/script/player.js"></script>
<script>
	import Vue from 'vue';
	import {api_base,api_goods,api_user,api_polyv} from '@/common/Request.js';
	export default {
	data () {
	  return {
	    goodsinfo: '',
		courseId:'',
		resourceId:0,
		vplayer:'',
		courseResourceTreeData:[],
		courseResourceTreeTrySeeData:[]
	  }
	},
	mounted(){
		if(this.$cookies.isKey("user_token"))
		{
			this.usertoken=this.$cookies.get("user_token");
			this.courseId=this.$route.query.courseId;
			this.resourceId=this.$route.query.resourceId;
			this.initData();
			
		}
	},
	methods: {
		initData(){
			api_goods.goods_detail(this.courseId).then(response => {
				this.goodsinfo = response.data;
				document.title=this.goodsinfo.name;
				this.courseResourceTreeListLoad();
			})
			
			console.log(this.resourceId);
			api_user.getPlayData(this.courseId,this.resourceId).then(res=>{
				console.log(res);
				this.videoplay(res.data)
			});
		},
		videoplay(videodata){
			console.log(videodata);
			this.vplayer=polyvPlayer({
			                  wrap: '#videoplayer',
							  width:'100%',
							  height:'100%',
			                  vid:videodata.vid,
			                  playsafe:videodata.token
			                });
			this.vplayer.on('serverError', function(event, errorCode) {
			  console.log(errorCode);
		});
	},
	courseResourceTreeListLoad(){
		api_user.getCourseResourceTree(this.courseId).then(res=>{
			console.log(res);
			const treedata=res.data.root.children;
			this.courseResourceTreeData=treedata;
			this.treefilter(this.courseResourceTreeData);
			console.log(this.courseResourceTreeData);
		})
	},
	treefilter(treeNodes){
		    if(!treeNodes||!treeNodes.length)return;
		    for(let i=0;i<treeNodes.length;i++){
		        let childs=treeNodes[i].children;
				if(treeNodes[i].isLeaf){
					let iconhtml="";
					if(treeNodes[i].item.resourceType==1){
						iconhtml="<i class='anticon anticon-desktop'></i> ";
						if(treeNodes[i].item.lessonStatus==3){
							treeNodes[i].item.alias=treeNodes[i].item.alias+" ("+this.formattime("YYYY-mm-dd HH:MM",new Date(treeNodes[i].item.lessonStartTime))+" 课程回放)";
						}
						else if(treeNodes[i].item.lessonStatus==0){
							treeNodes[i].item.alias=treeNodes[i].item.alias+" ("+this.formattime("YYYY-mm-dd HH:MM",new Date(treeNodes[i].item.lessonStartTime))+" 开始直播)";
						}
						else if(treeNodes[i].item.lessonStatus==1){
							treeNodes[i].item.alias=treeNodes[i].item.alias+" (直播中)";
						}
						else if(treeNodes[i].item.lessonStatus==2){
							treeNodes[i].item.alias=treeNodes[i].item.alias+" (直播完成待转码)";
						}
					}
					else if(treeNodes[i].item.resourceType==2){
						iconhtml="<i class='anticon anticon-play-circle-o'></i> ";
					}
					else if(treeNodes[i].item.resourceType==9){
						iconhtml="<i class='anticon anticon-user'></i> ";
					}
					treeNodes[i].title=iconhtml+treeNodes[i].item.alias;
					//treeNodes[i].title=treeNodes[i].item.alias;
					if(treeNodes[i].item.trySee=='1'){
						this.courseResourceTreeTrySeeData.push(treeNodes[i]);
					}
				}
				else{
					treeNodes[i].title=treeNodes[i].item;
					treeNodes[i].expanded=true;
				}
		        console.log(treeNodes[i])
		        if(childs&&childs.length>0){
		            this.treefilter(childs);
		        }
		    }
	},
	coursetreeplay(data){
		console.log(data);
		console.log(this.goodsinfo);
			if(data[0].isLeaf){
					if(data[0].item.resourceType==2){
					console.log("playvideo")
					this.$router.push({
					  path: "shiting",
					  query: { courseId: this.courseId,
							   resourceId: data[0].item.resourceId
					   }
					});
					location.reload();
				}
		}
},
formattime(fmt, date){
			        let ret;
			        const opt = {
			            "Y+": date.getFullYear().toString(),        // 年
			            "m+": (date.getMonth() + 1).toString(),     // 月
			            "d+": date.getDate().toString(),            // 日
			            "H+": date.getHours().toString(),           // 时
			            "M+": date.getMinutes().toString(),         // 分
			            "S+": date.getSeconds().toString()          // 秒
			            // 有其他格式化字符需求可以继续添加，必须转化成字符串
			        };
			        for (let k in opt) {
			            ret = new RegExp("(" + k + ")").exec(fmt);
			            if (ret) {
			                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
			            };
			        };
			        return fmt;
	
	},

},
}
</script>

<style scoped>
	.ant-tree{
	  padding-left: 0.5rem !important;
	}
	
	::v-deep .ant-tree li  .ant-tree-node-content-wrapper{
	  white-space: normal !important;
	  max-width: 85%;
	}
	
	::v-deep span.ant-tree-switcher{
		background: none !important;
	}
</style>
